import { Controller } from 'stimulus'

/**
 * Manages submit logic for schedule call form (StimulusJS controller)
 *
 * @class ScheduleCallController
 * @memberof Controllers
 */
export default class extends Controller {
  static targets = [ 'slot', 'submit' ]

  /**
   * @function Controllers.ScheduleCallController.initialize
   * @memberof Controllers
   * @description Defines callbacks for event listener usage
   */
  initialize() {
    this.onSubmitEventCallback = event => { this._successMessage() }
  }

  /**
   * @function Controllers.ScheduleCallController.connect
   * @memberof Controllers
   * @description Adds event listeners
   */
  connect() {
    this.check()
    this.slotTargets.forEach(slot => {
      if (!slot.name.endsWith('[]')) {
        slot.name += '[]'
      }
    })

    this.element.addEventListener('ajax:success', this.onSubmitEventCallback)
    this.timer = setInterval(this.maybeExpireSlots.bind(this), 1000)
  }

  /**
   * @function Controllers.ScheduleCallController.teardown
   * @memberof Controllers
   * @description Removes event listener from document on teardown.
   */
  teardown() {
    this.element.removeEventListener('ajax:success', this.onSubmitEventCallback)
    clearInterval(this.timer)
  }

  /**
   * @function Controllers.ScheduleCallController.check
   * @memberof Controllers
   * @description Ensures one of the slots has a value before enabling submit
   */
  check() {
    let disabled = true
    this.slotTargets.forEach(slot => {
      if (slot.value !== '') {
        disabled = false
      }
    })

    this.submitTarget.disabled = disabled
  }

  /**
   * @function Controllers.ScheduleCallController.maybeExpireSlots
   * @memberof Controllers
   * @description Inspect all slots and remove time slots that are within our specified expiration threshold.
   *              defaults to 10 minutes if not specified otherwise.
   *              e.g. `data-schedule-call-expire-within="15"`
   */
  maybeExpireSlots() {
    const now = new Date()
    let expireWithin = parseInt(this.data.get('expireWithin'))
    if (Number.isNaN(expireWithin)) { expireWithin = 10 } // if optional data attr not provided

    this.slotTargets.forEach(slot => {
      slot.options.forEach((option, index) => {
        const timestamp = option.value
        if (timestamp == '') { return }
        const slotTime = new Date(timestamp)
        const minsAway = parseInt((slotTime - now) / 60000)
        if (minsAway < expireWithin) {
          slot.remove(index)
        }
      })
    })
  }

  //
  // "Private" methods
  //

  /**
   * @function Controllers.ScheduleCallController._successMessage
   * @memberof Controllers
   * @description Inserts the message to display when successful
   */
  _successMessage() {
    this.element.innerHTML = `
      <div class="scheduler__section scheduler__section--call-out">
        Thank you, your appointment has been scheduled. We will call you at that time.
      </div>
    `
  }
}
